/**
 * The names of the languages Alternis processes (`shared/utils/alternis/languages.ts`), as
 * alternis_voip names them (`client/public/locales/de.json` `lang.*`, dev @ 128cfc3). Keyed by
 * the language code, in that list's order. Looked up by code.
 */
export default {
	lang: {
		ar: "Arabisch",
		cs: "Tschechisch",
		da: "Dänisch",
		de: "Deutsch",
		el: "Griechisch",
		en: "Englisch",
		es: "Spanisch",
		fa: "Persisch",
		fi: "Finnisch",
		fr: "Französisch",
		hu: "Ungarisch",
		it: "Italienisch",
		lv: "Lettisch",
		nl: "Niederländisch",
		no: "Norwegisch",
		pl: "Polnisch",
		pt: "Portugiesisch",
		ro: "Rumänisch",
		ru: "Russisch",
		sk: "Slowakisch",
		sl: "Slowenisch",
		sv: "Schwedisch",
		tr: "Türkisch",
		uk: "Ukrainisch",
		vi: "Vietnamesisch",
		zh: "Chinesisch",
		az: "Aserbaidschanisch",
		bg: "Bulgarisch",
		bs: "Bosnisch",
		et: "Estnisch",
		hi: "Hindi",
		hr: "Kroatisch",
		id: "Indonesisch",
		ja: "Japanisch",
		ko: "Koreanisch",
		lt: "Litauisch",
		mk: "Mazedonisch",
		ms: "Malaiisch",
		sr: "Serbisch",
		ta: "Tamil",
		th: "Thai",
		ur: "Urdu",
	},
};
